import dayjs from 'dayjs'
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter'
import 'dayjs/locale/ja'
dayjs.locale('ja')
dayjs.extend(isSameOrAfter)

// NOTE: まだ一般化できないのでタイムスケジュール用のユーティリティとして切り出した

const MAX_STRING_LENGTH = 17
const getFormattedNow = (): string => dayjs().format('YYYY-MM-DD HH:mm:ss')

export function truncateEventDetailString(str: string): string {
  if (str.length <= MAX_STRING_LENGTH) return str
  return `${str.substring(0, MAX_STRING_LENGTH)}…`
}

export const composeDateFromTimeString = (
  baseDate = getFormattedNow(),
  timeStr = '00:00'
): Date => {
  return dayjs(`${baseDate.slice(0, 10)}T${timeStr}:00`).toDate()
}

export function isNowBeforeTimeString(
  currentDate = getFormattedNow(),
  eventDate = getFormattedNow()
) {
  return function(startTime = ''): boolean {
    if (startTime === '') return false
    const startDate = composeDateFromTimeString(eventDate, startTime)
    return dayjs(currentDate).isBefore(startDate)
  }
}

export function isNowAfterTimeString(
  currentDate = getFormattedNow(),
  eventDate = getFormattedNow()
) {
  return function(endTime = ''): boolean {
    if (endTime === '') return false
    const endDate = composeDateFromTimeString(eventDate, endTime)
    return dayjs(currentDate).isSameOrAfter(endDate)
  }
}

export function isNowBetweenTwoTimeString(
  currentDate = getFormattedNow(),
  eventDate = getFormattedNow()
) {
  return function(startTime = '', endTime = ''): boolean {
    if (startTime === '' || endTime === '') return false
    const isBefore = isNowBeforeTimeString(currentDate, eventDate)(startTime)
    const isAfter = isNowAfterTimeString(currentDate, eventDate)(endTime)
    return !isBefore && !isAfter
  }
}

export const addHalfHourToTimeString = (time: string): string => {
  if (time === '') return ''
  const hour = time.split(':')[0]
  const minute = time.split(':')[1]
  let newHour, newMinute
  if (minute == '30') {
    newHour = String(Number(hour) + 1)
    newMinute = '00'
  } else {
    newHour = hour
    newMinute = '30'
  }
  return `${newHour}:${newMinute}`
}

export function isTouchDevice() {
  return 'ontouchstart' in window || navigator.maxTouchPoints > 0
}
